import React, { useEffect, useContext, useState } from 'react';

import AppContext from '../hooks/AppContext'
import SearchParamContext from '../hooks/SearchParamContext'

import MainPage from '../_template/MainPage'

import ListaPendencias from '../components/ListaPendencias'

const Pendencias = (props) => {

  const { instanciaInfo, setLoading, pendencias } = useContext(AppContext);  
  const { tvMode } = useContext(SearchParamContext); 
  
  const[resolvidas, setResolvidas] = useState();
  
  //Desativa o loading para esta tela
  useEffect(()=>{
    setLoading(!instanciaInfo)
  },[instanciaInfo])

  useEffect(()=>{
    let numResolvidas=0
    if(pendencias?.length>0){
      pendencias?.forEach(item =>{
        if(item?.valido){
          numResolvidas+=1;
        }
      })
      setResolvidas(numResolvidas)
    }
  },[pendencias])
      
  return (      
    <MainPage titulo={"Pendências"}
      resumoTitulo="Resumo"
      renderPendencias pendencias={pendencias?.length||0} pendenciasResolvidas={resolvidas||0}>

      <ListaPendencias mode={tvMode} secoesPendentes={pendencias}/>

    </MainPage>
  );
}


export default Pendencias;
